module.exports = __webpack_public_path__ + "img/Jo.a8a95c3d.png";